export default __webpack_public_path__ + "static/media/marble.50f6657f.png";